import React, { useState } from 'react';
import styles from '../styles/Prefs.module.css';
import { getApiUrl } from "../utils/config";

const AdminPasswordForm = ({ onPasswordCorrect }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            const API_URL = getApiUrl();
            const response = await fetch(`${API_URL}/api/admin/verify-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ password })
            });

            const data = await response.json();

            if (data.success) {
                onPasswordCorrect();
            } else {
                setError(data.message || 'Неверный пароль');
            }
        } catch (error) {
            setError('Ошибка соединения с сервером');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={styles["prefs-admin-container"]}>
            <div className={`${styles["card"]} ${styles["max-w-md"]} ${styles["mx-auto"]} ${styles["mt-12"]} ${styles["p-8"]}`}>
                <h2 className={`${styles["text-center"]} ${styles["mb-8"]}`}>
                    🔐 Доступ к админ-панели
                </h2>
                
                <form onSubmit={handleSubmit}>
                    <div className={styles["form-group"]}>
                        <label className={styles["form-label"]}>
                            Введите пароль:
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={`${styles["prefs-input"]} ${styles["form-input"]} ${styles["w-full"]}`}
                            placeholder="Пароль админ-панели"
                            required
                        />
                    </div>

                    {error && (
                        <div className={`${styles["alert"]} ${styles["alert-error"]}`}>
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={isLoading}
                        className={`${styles["btn-primary"]} ${styles["w-full"]} ${styles["p-4"]}`}
                    >
                        {isLoading ? 'Проверка...' : 'Войти'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminPasswordForm;
